import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div`
  width: 50rem;
  padding: 1.5rem 0;
`;

const Title = styled(Headline)`
  padding: 0 1.5rem;
`;

const Content = styled.div`
  padding: 1.5rem;
  margin: 1.5rem 0;

  border-top: 0.1rem solid ${pickColor('gray')};
  border-bottom: 0.1rem solid ${pickColor('gray')};

  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

const Description = styled(Headline)`
  margin-bottom: 0.8rem;
`;

const FieldWrapper = styled.div`
  text-transform: uppercase;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.2rem;

  padding-right: 1.5rem;
`;

export { ButtonWrapper, Container, Content, Description, FieldWrapper, Title };
